module.exports = __webpack_public_path__ + "img/Ayer Arguelles.df72fcd5.jpg";